<template>
    <div id="content">
      <button id="close" @click="close"> &times; </button>
      <h2>{{content.Title}}</h2>

    </div>
</template>
<script>
export default {
  props:['content'],
  methods: {
    close: function () {
      this.$emit('close');
    }
  }
    
}
</script>
<style scoped>
#content{
  background-color: rgba(5, 5, 5, 0.5);
  top:0px;
  height: 100%;
  width: 100%;
  position: absolute;
}
h2{
  margin: 20px;
}
#close{
  position: absolute;
  top: 10px;
  right: 10px;
  text-decoration: none;
  color: rgb(199, 199, 199);
  background: none;
  border: none;
}
</style>